module.exports = __webpack_public_path__ + "static/media/give4forest.a5d5d19a.svg";